export const mergeUniqueValues = (...valueLists: string[][]): string[] =>
  Array.from(new Set(valueLists.flat()));
